export const locale = {
    GENERAL: {
        Navigation: '导航',
        Home: '主页',
        Home2: '主页2',
        Standard: '标准',
        Student: '学生',
        Case: '案例',
        EditProfile: '编辑配置',
        Inbox: '收件箱',
        Calendar: '日历',
        Setting: '设置',
        LogOut: '注销',
        SearchMenu: '搜索菜单',
        Notifications: '通知',
        NoRecordFound: '找不到记录',
        SeeAll: '查看全部',
        Login: '登录',
    },
    STUDENT: {
        Student: '学生',
        StudentNo: '学生编号',
        LastName: '姓名',
        Gender: '性别',
        CenterName: '中心',
        Phone: '手机号码',
        Mobile: '电话号码',
        Center: '中心',
        Telephone: '电话号码',
        Age: '年龄',
    },
    HOME: {
        name: '姓名',
        name2: '姓名2',
        gender: '性别',
        center: '中心',
        selectTwo: '第二选择',
        email: '邮箱',
        birthday: '生日',
        locale: 'cn',
        Male: '男',
        Female: '女',
        Submit: '提交',
        Form: '表单',
    },
    ASelect: {
        name: '姓名',
        select: '选择一个项目',
    },
    FullName: '学生姓名',
    Color: '颜色',
    Student: '学生',
    StudentNo: '学生编号',
    LastName: '姓名',
    Gender: '性别',
    CenterName: '中心',
    Phone: '手机号码',
    Mobile: '电话号码',
    Center: '中心',
    Telephone: '电话号码',
    Age: '年龄',
    Name: '姓名',
    Male: '男',
    Female: '女',
    Birthday: '生日',
    Email: '邮箱',

    Save: '保存',
    Search: '搜索',
    Reset: '重置',
    Select: '选择',
    Add: '添加',
    Remove: '删除',
    AddStudent: '添加学生',
    Import: '导入',
    Delete: '删除',
    Cancel: '取消',
    AdvanceSearch: '高级搜索',
    RemoveStudent: '移除学生',
    SelectCurrent: '选择当前记录',
    SelectAll: '选择全部记录',

    ConfirmDelete: '确认要删除吗？',
}
